import { useTranslation } from 'next-i18next';
import { memo } from 'react';
import gazetteer, { CountryCodes, type Market } from '@bridebook/toolbox/src/gazetteer';
import { IUISupplier } from '@bridebook/toolbox/src/types';
import { Box } from '@bridebook/ui';
import { IconBudget } from '@bridebook/ui/src/icons';
import { getPricingCategoryByIndicator } from '@bridebook/web/app-shared/lib/supplier/utils';
import { getPricingValueString } from '@bridebook/web/lib/supplier/utils';
import { IconClass } from '@bridebook/web/lib/ui/constants';
import { arePropsEqual } from '@bridebook/web/lib/utils';
import componentStyles from './supplier-properties.style';

interface IProps {
  market: Market;
  supplier: IUISupplier;
  hidePrice?: boolean;
}

const PropertiesComponent = ({ market, supplier, hidePrice }: IProps) => {
  const styles = componentStyles();
  const { t } = useTranslation('supplierCard');
  const { accommodationRooms: bedrooms, capacityDining: seats, countryCode } = supplier;
  const currency = gazetteer.getMarketByCountry(countryCode ?? CountryCodes.GB).currency;
  const hasSeats = !!(seats && seats > 0);
  const hasBedrooms = !!(bedrooms && bedrooms > 0);
  const pricingCategory = getPricingCategoryByIndicator(supplier.pricingIndicator);

  return (
    <Box as="ul" style={styles.wrapper}>
      {hasSeats && (
        <Box as="li" style={styles.property}>
          <span className={IconClass.Guest} style={styles.icon} />
          {seats}
        </Box>
      )}
      {hasBedrooms && (
        <Box as="li" style={styles.property}>
          <span className={IconClass.Bedroom} style={styles.icon} />
          {bedrooms}&nbsp;
          <Box as="span" style={styles.propertyAccomodation}>
            {t('infoCard.bedrooms.nonZero', {
              count: bedrooms,
            })}
          </Box>
        </Box>
      )}
      {!hidePrice && (
        <Box as="li" style={styles.property}>
          <IconBudget borderColor="space60" width={16} pr={1} />
          {getPricingValueString(currency, market, supplier, pricingCategory, true)}
        </Box>
      )}
    </Box>
  );
};

export const Properties = memo(PropertiesComponent, arePropsEqual);
